<template>
        <div class="left">
                <div class="logo2" @click="gotoKanban">
                    <img :src="fromL.basics.logo ? fromL.basics.logo : require('../assets/img/moren.png')" alt="">
                </div>
                <!-- 默认首页 -->
                <div class="ulTOne" @click.stop="goto(0)">
                    <div class="menu_left">
                        <img  class="logo" :src="activeL === 0 ? require('../assets/img/sy.svg') : require('../assets/img/sy1.svg')" alt="">
                        <span class="barT" :style="{color : activeL === 0 ? '#0051D7' :''}">{{ lang.homepage }}</span>
                    </div>
                </div>

                <!-- 权限 -->
                <div style="width: 100%;" v-for="(item,index) in appSignL(roleUser.type == 1 ? fromL.admin.sidebar.list : (fromL.admin.sidebar.stuList ? fromL.admin.sidebar.stuList : fromL.admin.sidebar.list))"
                    :key="index+1">
                    <!-- 渲染菜单类型 -->
                     <template v-if="item.menuName">
                        <div class="ulTOne" v-if="appSignL(item.children).length > 0">
                          <!-- 二级导航 -->
                            <div class="ulTCopy">
                                <div class="ulTCopyTit">
                                    <span>{{ item.menuName }}</span>
                                </div>
                                <div class="ulTCopyHei">
                                    <div class="ulTCopyTxt" 
                                    v-for="(i,ind) in appSignL(item.children)"
                                        @click="levTwo(i,ind,index)" :key="ind+'a'">
                                            <div class="ulTCopyTxt"
                                             :style="{background : (activeLTwo === index+1 +'+' + ind)? '#0663FE' : '',color: (activeLTwo === index+1 +'+' + ind)? '#fff' :''}"
                                            v-for="(p,pin) in AppCon(i.url)" :key="pin+'p'">
                                                <div class="ulTCopyConT">{{ p.name }}</div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <div class="menu_left">
                            <img :src="activeL === (index +1) ? item.menuActiveIcon : item.menuIcon" class="logo" alt="">
                            <span class="barT" :style="{color : activeL === (index +1) ? '#0051D7' :''}">{{ item.menuName }}</span>
                        </div>
                        
                     </div>
                     </template>
                     
                   
                
                    <!-- 渲染平台工具类型 -->
                    <div style="width: 100%;" @click.stop="goto(index,item)" 
                     v-else>
                        <div class="ulTOne" 
                        v-for="(p,pin) in AppCon(item.url)" :key="pin+'p'">
                                <div class="menu_left" @mouseenter="mouGet(item.toolId)" >
                                    <img class="logo"  
                                    :src="activeL === (index +1) ? p.activeIcon : p.defaultIcon" 
                                    alt="">
                                    <span class="barT" :style="{color : activeL === (index +1) ? '#0051D7' :''}">
                                        {{ p.name }}
                                    </span>
                                </div>
                                <!-- 二级导航 -->
                                <div class="ulTCopy" v-if="item.toolId.includes('appStore') && ((cocoFlowList[0] && cocoFlowList[0].length) || (cocoFlowList[1] &&  cocoFlowList[1].length))">
                                    <div class="ulTCopyTit">
                                        <span v-if="prefixL == 'liyuan_'">{{ lang.AIapp }}</span>
                                        <span v-else>CocoFlow</span>
                                    </div>
                                    <div class="ulTCopyHei" >
                                        <span v-if="cocoFlowList[0] && cocoFlowList[0].length" style="color: #00000066;">{{ lang.recentlyused }}</span>
                                        <div class="ulTCopyTxt"  
                                        v-for="(i,ind) in cocoFlowList[0]" 
                                        @click.stop="openNewWindow(i)" :key="ind+'ab'">
                                                <div class="ulTCopyConT">{{ i.name }}</div>
                                        </div>
                                        <span v-if="cocoFlowList[0] && cocoFlowList[1].length" style="color: #00000066;">{{ lang.MyCollection }}</span>

                                        <div class="ulTCopyTxt"
                                        v-for="(i,ind) in cocoFlowList[1]" @click.stop="openNewWindow(i)" :key="ind+'a'">
                                                <div class="ulTCopyConT">{{ i.name }}</div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                         
                    </div>
                </div>

        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '../store'
import { API_CONFIG } from "@/common/apiConfig";
import { myMixin } from "@/mixins/mixin.js"

    export default {
        mixins: [ myMixin ],
        props: {
            // 父组件传入的方法，调用后返回 { url, hash }
            getCurrentUrl: {
                type: Function,
                default: null
            }
        },
        computed: {
            ...mapGetters(['userinfo','userinfo2','fromL','appSign']),
            // 如果hk，com没有图标，默认使用cn的
            AppCon(){
                return function(c) {
                    let k = JSON.parse(JSON.stringify(c))
                    let data = k.filter(e=>{
                        // return e.region == this.roleUser.schoolArea || e.region == this.roleUser.orgArea
                        return e.region == this.$region
                    })

                    let data2 = k.filter(e=>{
                        return e.region == 'cn'
                    })
                    
                     // 如果hk，com没有图标，默认使用cn的
                    if (!data[0].activeIcon){
                        data[0].activeIcon = data2[0].activeIcon
                    }
                    if (!data[0].defaultIcon){
                        data[0].defaultIcon = data2[0].defaultIcon
                    }
                    if (!data[0].hoverIcon){
                        data[0].hoverIcon = data2[0].hoverIcon
                    }
                    if (!data[0].icon){
                        data[0].icon = data2[0].icon
                    }
                    if (!data[0].platformIcon){
                        data[0].platformIcon = data2[0].platformIcon
                    }
                    // console.log('data3',data);

                    return data
                };
            },
            // 筛选是否为管理员可见，是否被删除
            appSignL(){
                return function(val){
                    
                    let data = []
                    // if (this.roleUser.type == 2) {
                    //     val.forEach( e =>{
                    //         if (e.menuName || e.id == 'c59dac89-0bac-11f0-baea-005056924926' || e.id == "dd87149c-1f52-11f0-a66a-005056924926") {
                    //             data.push(e)
                    //         }
                    //     })
                    // } else 
                    if (this.roleUser.type == 1 && this.roleUser.role == 1) {
                        val.forEach( e =>{
                            if (e.menuName || e.status == 0) {
                               data.push(e)
                            }
                        })
                    } else {
                        val.forEach( e =>{
                            if (e.menuName || (e.isAdmin == '0' && e.status == 0)) {
                               data.push(e)
                            }
                        })
                    }
                    return data
                }
            },
            roleUser(){
                return Object.keys(this.userinfo2).length != 0 ? this.userinfo2 : this.userinfo
            }
        },
        data() {
            return {
                // 一级选中第几个
                activeL:0,
                visible:true,
                // 二级选中第几个
                activeLTwo: null,
                cocoFlowList:[],
                // 荔园集团下的学校 
                mergedList: [
						"3823a6a5-1b6e-11f0-a66a-005056924926",
						"292e34dc-1b6e-11f0-a66a-005056924926",
						"21d6b367-1b6e-11f0-a66a-005056924926",
						"1a1a172d-1b6e-11f0-a66a-005056924926",
						"1197f86b-1b6e-11f0-a66a-005056924926",
						"f235659b-1b6d-11f0-a66a-005056924926",
						"d87b62d3-1b6d-11f0-a66a-005056924926",
						"c25ea59b-1b6d-11f0-a66a-005056924926",
                        "17638689-b0e6-11f1-8d76-005056924926",
                        "0cd218f2-b0e6-11f1-8d76-005056924926",
                        "04ae2e8a-b0e6-11f1-8d76-005056924926",
                        "f8107f03-b0e5-11f1-8d76-005056924926",
                        "f01f0847-b0e5-11f1-8d76-005056924926",
                        "e6f8256d-b0e5-11f1-8d76-005056924926",
                        "d0973bde-b0e5-11f1-8d76-005056924926",
                        "b5d67b8c-b0e5-11f1-8d76-005056924926",
                        "7fa0994b-b0e5-11f1-8d76-005056924926",
                        "aa45263b-96fc-11f1-9985-005056924926",
				]
            }
        },
        methods: {
            ...mapActions({
                logout: 'user/logout'
            }),
            // 跳转到看板
            async gotoKanban(){
                if (!this.mergedList.includes(this.roleUser.org)) return console.log('非荔园平台不可进入');
                try {
                     window.topU.gotype = '' 
                } catch (error) {
                    console.log(error);
                }
                await store.commit('user/SET_USERINFO2', {})
                // 重新获取基础数据
                await store.dispatch('user/getschPerInfo')
                // 清除数据让数据看板中的埋点正常（不能这样写，那点返回校区的话就完蛋了）
                // await store.commit('user/SET_USERINFO2', {})
                let num = this.userinfo.type == 1 && this.userinfo.role == 1 && this.userinfo.rrole == 1 ? 1 : 2
                this.$router.push({
                    path: '/KanBan',
                    query: { 
                        index: num, 
                    }
                });
               
            },
            mouGet(val){
                
                if(!val.includes('appStore')) return
                // console.log('val',val);
                this.getData()
            },
            // 点击一级导航
            async goto(index,val = null){
                // 调用父组件方法并直接获取返回值
                const result = this.getCurrentUrl ? this.getCurrentUrl() : '';

                console.log('result',result);
                
                // console.log('goto',val);
                if (this.appSign == "cocobookllm" && (val == null || val.toolId != "cocobookllm") && result == 'pptEasy' ) {
                    this.$confirm(this.lang.ssSwitchwillnotcachedatapage, this.lang.tip, {
                        confirmButtonText: this.lang.confirm,
                        cancelButtonText: this.lang.Cancel,
                        type: "warning",
                    })
                    .then(() => {
                        this.gotocopy(index,val)
                    })
                    .catch(() => {
                        console.log('取消');
                    });
                }else{
                    this.gotocopy(index,val)
                }

            },
            async gotocopy(index,val = null){
                try {
                     window.topU.gotype = '' 
                } catch (error) {
                    console.log(error);
                }

               // 清空二级菜单选中状态
                this.activeLTwo = ''
                // val = null 就是点击了首页
                if (val) {
                    this.activeL = index + 1
                    // 设置选中的 typeId
                    if (val.typeId) {
                        store.commit('user/SET_SELECTED_TYPE_ID', val.typeId);
                    }
                }else{
                    // 点击首页清空内容,并把标识去除
                    await store.commit('user/SET_AppSIGN', '')
                    // 设置首页的 typeId
                    store.commit('user/SET_SELECTED_TYPE_ID', 'home');

                    this.$emit('getPer')
                    this.activeL = index
                    return
                }
           

                console.log('this.appSign',this.appSign);
                console.log('val.toolId',val.toolId);
                // 点击相同应用不刷新  
                if (this.appSign == val.toolId) return

                // 更新标识
                await store.commit('user/SET_AppSIGN', val.toolId)

                let url = ''

                // 查出对应账号的应用区域地址
                val.url.forEach(e => {
                    // if (e.region == this.roleUser.schoolArea || e.region == this.roleUser.orgArea) {
                    if (e.region == this.$region) {
                        url = e.url
                    }
                });

                let _userinfo = this.roleUser, //登录用户信息
                { userid: _userid, organizeid: _oid, type: _type, org: _org, role: _role, classid: _classId } = _userinfo; // 解构赋值获取用户信息
                const _TscreenType = 1, _SscreenType = 3; // 常量定义
                let queryString = ''
                if(val.argumentList && val.argumentList.length){
                    const paramsMap = {
                        userid: _userid,
                        org: _org,
                        oid: _oid,
                        tType: _type,
                        role: _role,
                        classId: _classId,
                        TscreenType: _TscreenType,
                        SscreenType: _SscreenType
                    };

                    const canshu = val.argumentList
                .filter(param => paramsMap[param] !== undefined || param === 'type')
                .map(param => param === 'type' ? `tType=${paramsMap['tType']}` : `${param}=${paramsMap[param]}`);

                    queryString = canshu.length ? (url.includes('?') ? '&' : '?') + canshu.join('&') : ''; // 生成查询字符串
                }

                let _url = url + queryString
                // if (val.toolId == "futureClass") { 没必要无用的
                //     _url = url + queryString +'&ly=1'
                // } else if (val.toolId == "AIPopCourse") { 后端已加
                //     // ai通识课(ai6)为了隐藏侧边栏与顶部 
                //     _url = url + queryString +'&gotype=1'
                // }else if (val.toolId == "artintellCou") { 后端已加
                //     // 笔架山人工智能课程（ai6）专属样式
                //     _url = _url +'&gotype=bjs'
                // } else if (val.toolId == "classroomOb" || val.toolId == "claevasys") { 后端已加
                //     // 新版课堂观察 课堂教学评价系统（课堂观察系统）
                //     _url = url + queryString +'&showIntroduceType=1'
                // } else if (val.toolId == "crossstysys") { 后端已加
                //     // 跨学科学习系统（协同建构）
                //     _url = url + queryString +'&ly=1&person=liyuan'
                // } else{
                //     _url = url + queryString
                // }
                // if(val.toolId == 'study' && this.roleUser.type == 2){
                //     _url = _url.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
                // }
                // console.log('_url',_url);

                    // let kpl = ` <iframe 
                    //                 allow= "camera *; microphone *;display-capture;midi;encrypted-media;"
                    //                 frameborder="no" 
                    //                 border="0" 
                    //                 style="border:0;width:100%;height:100%;" 
                    //                 src="${_url}" 
                    //                 ref="${val.toolId}"
                    //                 >
                    //             </iframe>`

                let pl = {json:_url ,stateL :true,toolId :val.toolId}

                // 添加打开应用
                this.$emit('AddAppJson',pl)

                this.addOp3('1', "", { type:this.prefixL + val.toolId + (this.roleUser.type == 1 ? '_teacher' : '_student') + "_open" }, "success")

            },
            
            // 获取cocoFlow收藏与历史使用记录
            getData(){                
                let params = [
                    {
                        functionName: API_CONFIG.ajax_appStoreSave.functionName,
                        uid: this.roleUser.userid, 
                    },
                ];
                
                this.$ajax
                    .post(API_CONFIG.baseUrl, params)
                    .then((res) => {
                        this.cocoFlowList = [res.data[0],res.data[1]]
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message.error(this.lang.FailedcocoFlow);
                    });
            },
            // 点击二级导航
            async levTwo(val,index,aInd){  
                 // 调用父组件方法并直接获取返回值
                 const result = this.getCurrentUrl ? this.getCurrentUrl() : '';

                 console.log('result',result);   
                if (this.appSign == "cocobookllm" && val.toolId != "cocobookllm" && result == 'pptEasy') {
                    this.$confirm(this.lang.ssSwitchwillnotcachedatapage, this.lang.tip, {
                        confirmButtonText: this.lang.confirm,
                        cancelButtonText: this.lang.Cancel,
                        type: "warning",
                    })
                    .then(() => {
                        this.evTwoCopy(val,index,aInd)
                    })
                    .catch(() => {
                        console.log('取消');
                    });
                }else{
                    this.evTwoCopy(val,index,aInd)
                }
            },
            async evTwoCopy(val,index,aInd){
                // console.log('val,index,aInd',val,index,aInd);
                try {
                     window.topU.gotype = '' 
                } catch (error) {
                    console.log(error);
                }

                
                this.activeL = ''
                this.activeL = aInd +1
                this.activeLTwo = `${aInd + 1}+${index}`
                
                // 设置选中的 typeId
                if (val.typeId) {
                    store.commit('user/SET_SELECTED_TYPE_ID', val.typeId);
                }

                console.log('this.appSign',this.appSign);
                console.log('val.toolId',val.toolId);

                
                // 点击相同应用不刷新
                if (this.appSign == val.toolId) return

               // 更新标识
                await store.commit('user/SET_AppSIGN', val.toolId)
                
                let url = ''
                val.url.forEach(e => {
                    // if (e.region == this.roleUser.schoolArea || e.region == this.roleUser.orgArea) {
                    if (e.region == this.$region) {
                    // if (e.region == this.$region) {
                        url = e.url
                    }
                });

                let _userinfo = this.roleUser, //登录用户信息
                { userid: _userid, organizeid: _oid, type: _type, org: _org, role: _role, classid: _classId } = _userinfo; // 解构赋值获取用户信息
                const _TscreenType = 1, _SscreenType = 3; // 常量定义
                let queryString = ''
                if(val.argumentList && val.argumentList.length){
                    const paramsMap = {
                    userid: _userid,
                    org: _org,
                    oid: _oid,
                    tType: _type,
                    role: _role,
                    classId: _classId,
                    TscreenType: _TscreenType,
                    SscreenType: _SscreenType
                    };

                    const canshu = val.argumentList
                    .filter(param => paramsMap[param] !== undefined || param === 'type')
                    .map(param => param === 'type' ? `tType=${paramsMap['tType']}` : `${param}=${paramsMap[param]}`);

                    queryString = canshu.length ? (url.includes('?') ? '&' : '?') + canshu.join('&') : ''; // 生成查询字符串
                }
                let _url = url + queryString
                // if (val.toolId == "futureClass") {
                //     _url = url + queryString +'&ly=1'
                // } else if (val.toolId == "AIPopCourse") {
                //     // 为了隐藏侧边栏与顶部 
                //     _url = url + queryString +'&gotype=1'
                // } else if (val.toolId == "classroomOb") {
                //     // 为了隐藏侧边栏与顶部 
                //     _url = url + queryString +'&showIntroduceType=1'
                // } else{
                //     _url = url + queryString
                // }

                console.log('_url',_url);
                // if(val.toolId == 'study' && this.roleUser.type == 2){
                //     _url = _url.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
                // }
                // let kpl = ` <iframe 
                //                 allow= "camera *; microphone *;display-capture;midi;encrypted-media;"
                //                 frameborder="no" 
                //                 border="0" 
                //                 style="border:0;width:100%;height:100%;" 
                //                 src="${_url}" 
                //                 ref="pageCon"
                //                 >
                //             </iframe>`

                let pl = {json:_url ,stateL :true,toolId :val.toolId}

                this.addOp3('1', "", { type:this.prefixL + val.toolId +(this.roleUser.type == 1 ? '_teacher' : '_student') +  "_open" }, "success")

                this.$emit('AddAppJson',pl)
            },
            // 打开ai应用
            openNewWindow(val) {
                console.log(val);
                
                // // 基本用法：打开指定 URL
                window.open(val.url, "_blank");
                this.addOp3('1', "", {id :val.id,name:val.name ,type:this.prefixL +(this.roleUser.type == 1 ? '_teacher' : '_student') +   "appstoreOpen" }, "success")

            },
        },
       
       
    }
</script>

<style scoped>
.ulTCopy{
    height: 90%;
    width: 184px;
    overflow: hidden;
    background-color: rgb(255 255 255 / 98%);
    border-radius: 12px;
    position: fixed;
    left: -105px;
    top: 70px;
    z-index: -100;
    transition: transform .5s ease;
}


.ulTOne:hover .ulTCopy{
    display: block !important;
    transform: translateX(194px) !important; /* 初始位置在视图之外 */
    z-index: -100;
    box-shadow: 0px 6px 30px 5px #0000000D;
}


.logo{
  margin: auto;
  width: 24px;
  height: 24px;
}

.iconW{
    width: 30px;
    height: 30px;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 1px;
    box-sizing: border-box;
}
.logo2 {
    cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.logo2 img{
    width: 60px;
    height: 60px;
}

.userInfo{
  width: 80px;
  color: #374151;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
  background-color: #fff;
  padding-bottom: 20px;
}
.left {
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
    width: 80px;
    height: 100%;
    padding:23px 6px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    overflow: auto;
    border-right: 1px #D5D5D5 solid;
    overflow-x: hidden;
}

.ulTOne{ 
    width: 100%;
    border-radius: 10px;
    display: flex;
    height: 48px;
    flex-wrap:nowrap;
    align-content: center;
    justify-content: center;
    position: relative;
}


.barT{
    font-size:10px;
    width: 80px;
    /* overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; */
    text-align: center;
    flex-wrap: wrap;
}

.menu_left {
  width: 32px;
  height: 42px;
  font-size: 10px;
  color: #64748b;
  box-sizing: border-box;
  cursor: pointer;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}



.ulTCopyTit{
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0px;
    color: #000;
    height: 40px;
    padding: 12px 16px;
    box-sizing: border-box;
    border-bottom: .5px #e5e7eb solid;
    background: #fff !important;
}
.ulTCopyHei{
    display: flex;flex-direction: column;
    gap: 10px;
    overflow: auto;
    padding: 10px;
    overflow-x: hidden;
    height: calc(100% - 72px);
}
.ulTCopyTxt{
    box-sizing: border-box;display: flex;
    align-items: center;
    color: #374151;
    width: 100%;
    border-radius: 10px;
    font-size: 16px;
    margin: 0;
}
.ulTCopyTxtBlock{
    width: 100%;
}
.ulTCopyConT {
    width: 100%;
    font-size: 12px;
    cursor: pointer;
    border-radius: 8px;
    padding: 8px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
   
}
.ulTCopyConT:hover{
    background: #f6f1f1;
    color: #000;
}
.ulTCopyTxtCon{
   display: flex;align-items: center;width: 100%;
}
/* .ulTCopyTxt:hover{
    background-color: #f3f4f6 !important;
} */
.cha:hover{
    color: #000 !important;
}


.ovlH{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>